import Markdown from "../Markdown/Markdown";

interface ContentRendererProps {
  content_md?: string | any; // Markdown string
  description?: any; // Ignored - only using description_md
  description_md?: string | any; // Markdown string (for lessons)
  maxSize?: string;
}

/**
 * ContentRenderer component that only uses markdown (content_md/description_md)
 * Ignores rich text blocks (content/description)
 */
const ContentRenderer = ({
  content_md,
  description_md,
  maxSize = "4xl",
}: ContentRendererProps) => {
  // Helper to ensure markdown is a string
  const getMarkdownString = (md: any): string | null => {
    if (!md) return null;
    if (typeof md === 'string') {
      return md.trim() || null;
    }
    // If it's an object/array, skip it (shouldn't happen with proper markdown)
    if (typeof md === 'object') {
      return null;
    }
    return String(md).trim() || null;
  };

  // For regular content fields - only use markdown
  const markdownContent = getMarkdownString(content_md);
  if (markdownContent) {
    return <Markdown content={markdownContent} maxSize={maxSize} />;
  }
  
  // For description fields (lessons) - only use markdown
  const markdownDescription = getMarkdownString(description_md);
  if (markdownDescription) {
    return <Markdown content={markdownDescription} maxSize={maxSize} />;
  }
  
  return null;
};

export default ContentRenderer;
